<template>
  <div class="basket-item-component d-flex align-center justify-space-between">
    <div class="food-info-section">
      <span class="food-name font-weight-bold">{{ item.menuItem.name }}</span>
      <span v-if="item.modificationMenuItem" class="d-block modification-info">
        Модификатор:
        <span class="font-weight-medium">{{
          item.menuItem.modifications[0].modification.name
        }}</span>
      </span>
      <span v-if="item.comment" class="modification-info">
        Комментарий:
        <span class="font-weight-medium">{{ item.comment }}</span>
      </span>
    </div>
    <span class="price font-weight-medium">{{ item.price }} ₽</span>
    <v-btn class="button-delete" color="#ffffff" fab light depressed text>
      <font-awesome-icon icon="times" />
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'BasketItem',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
  }
</script>

<style lang="less" scoped>
.badge {
  width: 100%;
}
.basket-item-component {
  margin-bottom: 15px;
  padding: 24px 25px 22px 21px;
  background-color: @color-secondary;
  border-radius: 10px;
  transition: all 0.2s ease;
  height: 100%;

  &:last-child {
    margin-bottom: 0;
  }

  .food-info-section {
    flex: 1;

    .food-name {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 6px;
    }

    .price-info {
      font-size: 16px;
      line-height: 19px;
    }
  }

  .price {
    font-size: 28px;
    line-height: 1;
  }

  .button-delete {
    height: 50px;
    width: 50px;
    background-color: #ffffff !important;
    margin-left: 36px;

    svg {
      width: 18px;
      height: 18px;
      .fill-svg(@color-primary);
    }
  }

  .price-section {
    height: 50px;

    .button-edit {
      height: 50px;
      width: 50px;
      background-color: #d4ddeb !important;

      svg {
        width: 18px;
        height: 18px;
        .fill-svg(@color-secondary);
      }

      ::v-deep {
        .v-btn__content {
          text-align: center;
        }
      }
    }
  }
}
</style>
